import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { RewardDto } from '../../../models/dtos/reward.dto';
import { Errors } from '../../errors';
import getRewardRequest from './getReward.repository';
import { RewardRequest } from '../../../models/requests/reward.request';

type InitialState = {
  loading: boolean;
  data?: RewardDto;
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getReward = createAsyncThunk(
  'getReward',
  async (request: RewardRequest) => {
    return await getRewardRequest(request);
  }
);

const getRewardSlice = createSlice({
  name: 'getReward',
  initialState,
  reducers: {
    getRewardReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getReward.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      getReward.fulfilled,
      (state, action: PayloadAction<RewardDto>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getReward.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getRewardSlice.reducer;
export const { getRewardReset } = getRewardSlice.actions;
